import { api } from "../../../services/api";
const BASE = "/admin/delivery-times";
export const deliveryTimesService = {
  list: async (params) => (await api.get(BASE, { params })).data,
  get: async (id) => (await api.get(`${BASE}/${id}`)).data,
  create: async (payload) => (await api.post(BASE, payload)).data,
  update: async (id, payload) => (await api.patch(`${BASE}/${id}`, payload)).data,
  remove: async (id) => (await api.delete(`${BASE}/${id}`)).data,
};
